<cdx-slotted-modal (close)="close()" [size]="size" [mobileFullHeight]="true">
	<fulfilment-express-delivery modal-content></fulfilment-express-delivery>
</cdx-slotted-modal>
